/**
 * The payment methods that can be CHOSEN on new and manual orders: iDeal, Bancontact, Card and Other.
 * Cash, cash on delivery, Tikkie and bank transfer are no longer selectable. Orders that already carry such a value keep it
 * and still display it (the stored text is never changed); for accounting any value outside this list counts as "other".
 * The value is the text stored on the order (the backend normalises it: ideal, bancontact, card, other).
 */
export const SELECTABLE_PAYMENT_METHODS = [
    { value: 'iDeal', labelKey: null },
    { value: 'Bancontact', labelKey: null },
    { value: 'Card', labelKey: null },
    { value: 'Other', labelKey: 'createOrder.form.paymentOther' },
];

export const isSelectablePaymentMethod = (value) => SELECTABLE_PAYMENT_METHODS.some((m) => m.value.toLowerCase() === String(value || '').trim().toLowerCase());
